namespace $ {

	$mol_style_define( $shm_projects_goal_thinking, {
		flex: { basis: '30rem', grow: 1, shrink: 0 },
		minWidth: '24rem',
		Status: {
			color: $mol_theme.shade,
		},
		Body_content: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			height: '100%',
			maxHeight: '100%',
			minHeight: 0,
		},
		Thinking_box: {
			position: 'relative',
			flex: { grow: 1, shrink: 1, basis: 0 },
			minHeight: 0,
			minWidth: 0,
			padding: { top: $mol_gap.block },
		},
		Parts: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			width: '100%',
			height: '100%',
			minHeight: 0,
			gap: $mol_gap.text,
			overflow: 'auto',
		},
		Part: {
			flex: { direction: 'column', shrink: 0 },
			gap: $mol_gap.text,
			padding: $mol_gap.block,
		},
		Part_title: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
		},
		Part_text: {
			margin: '-0.75rem',
		},
	} )

}
